import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useTableauProfils } from '../../api/profils.js';
import { galerieALaction, galerieAModule } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { RaisonsCorrespondance } from './RaisonsCorrespondance.js';
import styles from '../tableau-de-bord/TableauDeBordPage.module.css';

export function BlocAPrevenir() {
  const { t } = useTranslation('regie');
  const { galerieSlug, galerie } = useShellContext();
  const ouvert =
    galerieAModule(galerie, 'profils-collectionneurs') && galerieALaction(galerie, 'profils:read');
  const tableau = useTableauProfils(galerieSlug, ouvert);
  if (!ouvert || !tableau.data?.oeuvres.length) return null;
  return (
    <section
      className={styles.suivi}
      data-ui="dashboard-followup"
      aria-label={t('profils.aPrevenir')}
    >
      <div className={styles.suiviEntete}>
        <h2>{t('profils.aPrevenir')}</h2>
      </div>
      <ul>
        {tableau.data.oeuvres.map((oeuvre) => (
          <li key={oeuvre.oeuvreId}>
            <Link to={`/${galerieSlug}/oeuvres/${oeuvre.oeuvreId}?onglet=a-prevenir`}>
              {oeuvre.titre}
            </Link>{' '}
            · {t('profils.nombreContacts', { count: oeuvre.nombre })}
            <p>
              <Link to={`/${galerieSlug}/contacts/${oeuvre.meilleureCorrespondance.contactId}`}>
                {oeuvre.meilleureCorrespondance.nom}
              </Link>
            </p>
            <RaisonsCorrespondance
              galerieSlug={galerieSlug}
              raisons={oeuvre.meilleureCorrespondance.raisons}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
